export const whitelistedOrigins = [
  'https://ads.microsoft.com',
  'https://ui.ads.microsoft.com',
  'https://ads-int.microsoft.com',
  'https://ui.ads-int.microsoft.com',
  'https://about.ads.microsoft.com',
  'https://ui.beta.ads-int.microsoft.com',
  'https://app1.ui.ads-int.microsoft.com:12000', /* for local testing */
];

export const checkifOriginIsWhitelisted = (origin = window.location.origin): boolean => whitelistedOrigins.includes(origin);
